// utils/apiUtils.js
export const getApiBaseUrl = () => {
  if (typeof window === "undefined") return "http://localhost:8000/v1";
  
  const hostname = window.location.hostname;
  if (hostname.includes(".")) {
    if (hostname.includes("app")) {
      return `https://${hostname.replace("app", "api")}/v1`;
    }
    return `https://api.${hostname}/v1`;
  }
  return "http://localhost:8000/v1";
};